import { Component } from "react";
import * as React from "react";
import SdsSubject from "../../../models/SdsSubject";
import {SchoolWorkloadConfig} from "../../../models/SchoolWorkloadConfig";
import {SubjectItem} from "./OnboardSubjectMergePage/SubjectItem";
import * as _ from "lodash";
import SelectableSubjectCard from "./SelectableSubjectCard";

interface SubjectExcludeEditorProps {
    schoolWorkloadConfig: SchoolWorkloadConfig;
    sdsSubjects: SdsSubject[];
    
    onChange(updatedConfig: SchoolWorkloadConfig): void;
}

interface SubjectExcludeEditorState {
}

const excludedSubjectCodes = (config: SchoolWorkloadConfig): string[] => {
    const codes = config.subjectExcludes?.sourceSubjectCodes || [];
    return codes.map(c => c.toLowerCase())
}

export default class SubjectExcludeEditor extends Component<SubjectExcludeEditorProps, SubjectExcludeEditorState>
{
    constructor(props: SubjectExcludeEditorProps) {
        super(props);
        
        this.state = {
        };
    }
    async componentDidMount()
    {
        
    }

    private toggleExclude = (subjectCode: string) => {
        
        let currentExcludes = excludedSubjectCodes(this.props.schoolWorkloadConfig);
        let newExcludes = []; 
        if(_.includes(currentExcludes,subjectCode))
        {
            newExcludes = _.without(currentExcludes,subjectCode)
        }
        else
        {
            newExcludes =  [...currentExcludes,subjectCode]
        }

        const updatedConfig = _.cloneDeep(this.props.schoolWorkloadConfig);
        Object.assign(updatedConfig,{subjectExcludes: {sourceSubjectCodes: newExcludes}});
        
        this.props.onChange(updatedConfig);
    }

    componentDidUpdate(prevProps: Readonly<SubjectExcludeEditorProps>, prevState: Readonly<SubjectExcludeEditorState>, snapshot?: any): void
    {
    }
    
    public render()
    {
        const excludedCodes = excludedSubjectCodes(this.props.schoolWorkloadConfig);
        const subjectItems = this.props.sdsSubjects.map(sdsSubject => SubjectItem.fromSdsSubject(sdsSubject));
        
        const subjectExcludeCards = subjectItems.sort(SubjectItem.AlphabeticalCompare).map(subjectItem => {
            return (
                <SelectableSubjectCard
                    key={subjectItem.code}
                    subjectItem={subjectItem}
                    selected={_.includes(excludedCodes,subjectItem.code)}
                    toggleSelected={this.toggleExclude}
                    selectedClassName={"subject-card--excluded"}
                    iconName={"Blocked"}
                    iconLabel={"Exclude"}/>
            );
        });
        
        return (
            <div className={"flex-row flex--flow-wrap flex--justify-content-center"}>
                
                {subjectExcludeCards}
            </div>            
        );
    }
}